/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { When } from "react-if";
import styled from "styled-components";
import { Text, Navigation, theme, Box, ExtendedPopover } from "@nordcloud/gnui";
import { PopoverTrigger } from "~/components";
import { PathName } from "~/tools";
import { disabledStyle } from "./styles";

type Item = {
  label: string;
  onClick: () => void;
  customIcon?: PathName;
  disabled?: boolean;
};

type PopoverControlsProps = {
  items: Item[];
  size?: "small" | "large";
  disabled: boolean;
};

type Props = {
  isPaddingLeft?: boolean;
};

const StyleItem = styled(Navigation.Item)<Props>`
  cursor: pointer;
  user-select: none;
  padding-left: ${({ isPaddingLeft }) =>
    isPaddingLeft && theme.spacing.spacing04};
`;

export function PopoverControls({
  items,
  size = "small",
  disabled,
}: PopoverControlsProps) {
  return (
    <ExtendedPopover
      placement="left"
      trigger={<PopoverTrigger {...{ size, disabled }} />}
      content={
        <When condition={!disabled}>
          <Box
            innerSpacing="spacing03"
            shadow="shadow04"
            data-cy="popover-actions"
          >
            <Navigation.Container popoverMenu>
              {items.map((item) => (
                <StyleItem
                  key={item.label}
                  onClick={item.disabled ? undefined : item.onClick}
                  isPaddingLeft
                >
                  <Text tag="span" css={disabledStyle(item.disabled)}>
                    {item.label}
                  </Text>
                </StyleItem>
              ))}
            </Navigation.Container>
          </Box>
        </When>
      }
    />
  );
}
